const prefix = mgcl_gallery_custom_links.prefix;
const domain = mgcl_gallery_custom_links.domain;
const restUrl = mgcl_gallery_custom_links.rest_url.replace(/\/+$/, "");
const apiUrl = mgcl_gallery_custom_links.api_url.replace(/\/+$/, "");
const pluginUrl = mgcl_gallery_custom_links.plugin_url.replace(/\/+$/, "");
const isPro = mgcl_gallery_custom_links.is_pro === '1';
const isRegistered = isPro && mgcl_gallery_custom_links.is_registered === '1';
const restNonce = mgcl_gallery_custom_links.rest_nonce;

export { prefix, domain, apiUrl, restUrl, pluginUrl, isPro, isRegistered, restNonce };
